import { ITreatmentStepDimension } from '../dimensions/treatment-step';
import { ITimestampedFact, ITreatmentStepScopedFact } from './common';

export interface ITreatmentStepEventFact
  extends ITreatmentStepScopedFact,
    Pick<ITreatmentStepDimension, 'treatments' | 'serviceCodes'>,
    ITimestampedFact {}
